interface ProcessTargetParam {
	messages: { [messageId: string]: string };
}

export default class ProcessTarget {
	public messages: { [messageId: string]: string };

	public constructor(params: ProcessTargetParam) {
		this.messages = params.messages;
	}
}